import * as mutations from './mutations'
import * as getters from './getters'
import * as actions from './actions'

export default {
  namespaced: true,
  state () {
    return {
      items: [],
      target: null,
      selection: [],
      editable: () => true,
      disabled: () => false
    }
  },
  mutations,
  actions,
  getters
}
